import React from 'react';

const JsonBlock = ({ title, value }) => (
  <div className="rounded-lg border border-slate-800 bg-slate-950/70 p-2">
    <div className="mb-1 text-[11px] uppercase tracking-wide text-slate-400">{title}</div>
    <pre className="max-h-44 overflow-auto whitespace-pre-wrap break-words text-[11px] text-slate-200">
      {JSON.stringify(value || {}, null, 2)}
    </pre>
  </div>
);

const AuditDetailDrawer = ({ open, log, onClose }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex justify-end bg-black/40">
      <aside className="h-full w-full max-w-xl overflow-auto border-l border-slate-800 bg-slate-900 p-4 text-slate-100">
        <div className="mb-3 flex items-center justify-between">
          <h3 className="text-sm font-semibold">Detail Audit</h3>
          <button type="button" onClick={onClose} className="rounded-md border border-slate-700 px-2 py-1 text-xs">Tutup</button>
        </div>

        <div className="space-y-2 text-xs">
          <div className="rounded-lg border border-slate-800 bg-slate-950/70 p-2"><span className="text-slate-400">Audit ID:</span> <span className="font-mono">{log?.auditId}</span></div>
          <div className="rounded-lg border border-slate-800 bg-slate-950/70 p-2"><span className="text-slate-400">Entity:</span> {log?.entityType} / <span className="font-mono">{log?.entityId}</span></div>
          <div className="rounded-lg border border-slate-800 bg-slate-950/70 p-2"><span className="text-slate-400">Action:</span> {log?.actionType}</div>
          <div className="rounded-lg border border-slate-800 bg-slate-950/70 p-2"><span className="text-slate-400">Actor:</span> {log?.actorType}:{log?.actorId}</div>
        </div>

        <div className="mt-3 space-y-2">
          <JsonBlock title="Previous State" value={log?.previousState} />
          <JsonBlock title="New State" value={log?.newState} />
          <JsonBlock title="Metadata" value={log?.metadata} />
        </div>
      </aside>
    </div>
  );
};

export default AuditDetailDrawer;
